import styled from 'styled-components';

import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Header, CenteredLoader, Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 80px;
  padding: 0px 125px;
`;

export const Section = styled.div`
  ${(props) => props.addBorder && `
    border: 1px solid #EAEAEA;
    border-radius: 3px;
    padding: 10px 20px;
  `}

  margin-bottom: 20px;
`;

export const Checkbox = styled(SemanticCheckbox)`
  margin-top: 10px;
`;

export const Title = styled(Header)`
  margin-bottom: 20px;
`;

export const Subtitle = styled(TextLayoutComponent)`
  font-size: 16px;
  font-weight: 500;

  && {
    margin-top: 6px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Message = styled(TextLayoutComponent)`
  ${({ daysLeft }) => daysLeft && `
    color: #e99484;
    font-style: italic;
  `}

  ${({ bold }) => bold && `
    font-weight: 500;
  `}

  max-width: 760px;
  margin-bottom: 5px;
`;

export const SavedCardsMessage = styled(TextLayoutComponent)`
  max-width: 760px;
  margin-bottom: 20px;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  ${({ bold }) => bold && `
    font-weight: 500;
  `}

  margin-bottom: 20px;
`;

export const SuccessMessage = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.success};
  font-weight: 500;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    min-width: 100px;
  }
`;

export const Divider = styled.hr`
  border-bottom: none;
  border-top: 1px solid ${(props) => props.theme.color.divider};
  margin-top: 20px;
  width: 550px;
`;

export const Loader = styled(CenteredLoader)``;

export const Link = styled.a``;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 200px;
  margin-top: 10px;
  align-self: flex-end;
`;

export const CreateCardContainer = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  width: 400px;

  .StripeElement {
    background: white;
  }
`;
